import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {UIRouter} from '@uirouter/angular';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {RoutePrefix} from '../shared/route-prefix';
import { DatatableViewComponent, RequestParams } from '@ngx-ivengi/crud';
import {Building} from './building.model';
import {BuildingService} from './building.service';
import {FileService} from '../file/file.service';

@Component({
  selector: 'app-building-datatable',
  templateUrl: './building-datatable.component.html'
})
export class BuildingDatatableComponent extends DatatableViewComponent<Building> implements OnInit, OnDestroy {

  @Output() onBuildingsLoaded = new EventEmitter<any>();
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public linkView: boolean = false;
  @Input() public requestParams: RequestParams;
  @Input() public displayActions: boolean = true;
  @ViewChild(ConfirmationModalComponent) public confirmationModal: ConfirmationModalComponent;

  private filterTimeout;

  constructor(
    private router: UIRouter,
    private buildingService: BuildingService,
    private fileService: FileService
  ) {
    super(buildingService);
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.buildingService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.requestParams.addSortParam({key: (this.linkView ? 'building.name' : 'name'), value: 'asc'});
    this.fetchData();
  }

  public fetchData(): void {
    this.loading  = true;
    this.buildingService.getAll(this.requestParams).subscribe((data: Building[]) => {
      this.rows = data.map((building: Building) => {
        if(building.notesFileId) {
          building.setNotesFileSrc(this.fileService.getLinkById(building.notesFileId));
        }
        return building;
      });

      this.onBuildingsLoaded.emit(this.rows);
      this.loading = false;
    });
  }

  public ngOnDestroy(): void {
    this.buildingService.clearRoutePrefix();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      if(this.routePrefix) {
        const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

        const prefix  = prefixParts.map((item) => {
          return `${item.entity}/${item.entityId}`;
        });

        this.buildingService.setRoutePrefix(prefix.join('/').toLowerCase());
      }
      this.buildingService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public filter(event) {
    if(this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    this.filterTimeout = setTimeout(() => {
      super.filter(event);
    }, 300);
  }

  public onRowClick(event) {
    if (this.router.stateService.current.name !== 'building') {
      return;
    }
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('building.edit', { buildingId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-datatable.component.ts